import { render, staticRenderFns } from "./Charge.vue?vue&type=template&id=c2f21198&scoped=true"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"
import style0 from "./Charge.vue?vue&type=style&index=0&id=c2f21198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f21198",
  null
  
)

export default component.exports